export const IP_INFO_TOKEN = process.env.VUE_APP_IP_INFO_TOKEN;
export const APPS_API = process.env.VUE_APP_APPS_API;
export const NUM_SERVER_URL = process.env.VUE_APP_NUM_SERVER_URL;

export const DATA_URL = process.env.VUE_APP_DATA_URL;

export const MODE = process.env.VUE_APP_MODE;

export const STAGE = process.env.VUE_APP_STAGE;
